import { PROMOTION_CODES, PROMOTION_DEFAULT_CODE } from "app/appConfig";
import {
  LEAD_SOURCE_LEVEL,
  PAGESIZE_ALL,
  TREATMENT_FREE,
  TYPE_CARD,
} from "app/common/LocalConst";
import { getPriceTypeService } from "app/common/LocalFunction";
import { RegisterCard } from "app/common/Model/RegisterCard";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingClientCard } from "app/services/ClientCardService";
import { getListCode } from "app/services/CustomerSourceService";
import { elasticTreatmentPlanCardHistory } from "app/services/ElasticPatient";
import { getAllServicesOfPatientById } from "app/services/PatientService";
import { getTreatmentTimesEachServices } from "app/services/ServiceRequestItem";
import {
  changeTreatment,
  getInitChangeTreatment,
  getListTreatmentPlanCard,
  getTreatmentPlanCardById,
  lockTreatment,
  pagingTreatmentPlanCard,
  removeTreatmentPlanCardUser,
  saveOrEditTreatmentPlanCard,
  unLockTreatment,
} from "app/services/TreatmentPlanCardService";
import { createPaymentVoucherWithListMethod } from "app/services/VoucherService";
import { pagingProgram } from "app/services/PromotionCRMService";
import { makeAutoObservable, runInAction } from "mobx";
import axios from "axios";
import ConstantList from "app/appConfig";
import { toast } from "react-toastify";

export default class RegisterTreatmentPlanStore {
  searchRegisterTreatmentPlan = {
    ...new SearchObject(),
    fromDate: new Date(new Date().getFullYear(), 0, 1),
    toDate: new Date(),
    type: TYPE_CARD[1].value,
  };
  initialDeposit = null;
  pageRegisterTreatmentPlan = new PageResponse();
  openCreateOrEditTreatmentPlanPopup = false;
  initRegisterTreatmentPlan = { ...new RegisterCard() };
  initChangeTreatmentPlan = {
    oldTreatmentPlanCard: {
      ...new RegisterCard(),
    },
    newTreatmentPlanCard: {
      ...new RegisterCard(),
    },
  };
  openAddTreatmentPlanAdvicePopup = false;
  openUpdateTreatmentPlanAdvicePopup = false;
  dataRegisterTreatmentPlan = [];
  searchListTreatmentPlanAdvice = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
  };
  openConfirmDelete = null;
  openConfirmMessage = null;
  openConfirmDeleteMessage = null;
  openInvalidMessage = null;
  openPopupPrintTreatmentPlan = false;
  dataPrintTreatmentPlan = null;
  openPopupPrintAll = false;
  allServicePatientData = null;
  selectedTreatmentPlan = null;
  openChangeTreatmentPlanPopup = false;
  openConfirmUnlock = null;
  treatmentFree = null;
  openConfirmLock = null;
  openConfirmError = null;

  openHistoryTreatmentPopup = false;
  searchDataHistory = null;
  pageDataHistory = new PageResponse();

  openPopupComfirms = false;
  responseDetailFormChangeTreament = null;
  listCodeSource = [];

  constructor() {
    makeAutoObservable(this);
  }

  handleOpenPopupTreatmentPlan = (state) => {
    this.openPopupPrintTreatmentPlan = state;
  };

  setSelectedRowTreatmentPlan = (row) => {
    this.selectedTreatmentPlan = [row];
  };

  handleOpenPopupPrintAll = async (patientId) => {
    try {
      const { data } = await getAllServicesOfPatientById(patientId);
      this.allServicePatientData = data;
      this.openPopupPrintAll = true;
    } catch (error) {
      toast.error("Có lỗi xảy ra khi lấy dữ liệu in");
      console.error(error);
    }
  };

  pagingRegisterTreatmentPlan = async () => {
    return await pagingTreatmentPlanCard({
      ...this.searchRegisterTreatmentPlan,
      getStaffRevenues: true,
    })
      .then(({ data }) => {
        this.pageRegisterTreatmentPlan = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ liệu trình khách hàng có lỗi");
      });
  };

  pagingRegisterTreatmentPlanAdvice = async () => {
    return await getListTreatmentPlanCard({
      ...this.searchListTreatmentPlanAdvice,
    })
      .then(({ data }) => {
        this.dataRegisterTreatmentPlan = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tư vấn khách hàng có lỗi");
      });
  };

  handleOpenPopupPrintTreatmentPlan = (rowData) => {
    this.dataPrintTreatmentPlan = rowData;
    this.openPopupPrintTreatmentPlan = true;
  };

  handleClosePrintTreatmentPlan = () => {
    this.openPopupPrintTreatmentPlan = false;
    this.openPopupPrintAll = false;
    this.dataPrintTreatmentPlan = null;
  };

  handleValidateMinMaxTreatmentPlan = (treatmentPlan, paServiceRegister) => {
    let serviceGroups = treatmentPlan?.serviceGroups || [];

    let inValidServiceGroup = serviceGroups.find((group) => {
      let min = group?.minLimit;
      let max = group?.maxLimit;
      const paServiceRegisterLimit =
        paServiceRegister?.filter(
          (el) => el?.service?.serviceGroup?.id === group?.serviceGroup?.id
        ) || [];
      const quantityService = paServiceRegisterLimit?.reduce((acc, curr) => {
        return acc + curr?.quantity;
      }, 0);

      return quantityService < min || quantityService > max;
    });
    return inValidServiceGroup || null;
  };

  saveOrUpdateRegisterService = async (values, actions) => {
    const serviceGroupsValid = this.handleValidateMinMaxTreatmentPlan(
      values?.clientCard,
      values?.paServiceRegister
    );
    if (serviceGroupsValid) {
      this.openInvalidMessage = `Số lượng dịch vụ trong nhóm ${serviceGroupsValid?.serviceGroup?.name} không hợp lệ ( tối thiểu: ${serviceGroupsValid?.minLimit}, tối đa: ${serviceGroupsValid?.maxLimit} )!`;
      if (actions) {
        actions.setSubmitting(false);
      }
      return;
    }
    try {
      const { data } = await saveOrEditTreatmentPlanCard(values);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmMessage = data?.responseDetail;
        }, 500);
        if (actions) {
          actions.setSubmitting(false);
        }
        return data;
      } else {
        if (data?.id) {
          toast.success("Đăng ký thẻ liệu trình thành công");
          if (values?.isContinue) {
            let revenueAllocations =
              this.treatmentFree?.revenueAllocations || [];
            let staffRevenues = [];
            if (revenueAllocations) {
              staffRevenues = revenueAllocations?.map((el) => ({
                position: el?.position,
                percentRevenue: el?.commissionRate,
                source: values?.patient?.currentPatientSource
                  ? values?.patient?.currentPatientSource
                  : values?.customerSourceWalkIn,
                actualAmount: 0,
                staff:
                  values?.patient?.currentConsultant?.position?.code ===
                    el?.position?.code
                    ? values?.patient?.currentConsultant
                    : values?.patient?.currentTelesale?.position?.code ===
                      el?.position?.code
                      ? values?.patient?.currentTelesale
                      : null,
              }));
            }
            this.initRegisterTreatmentPlan = {
              ...new RegisterCard(),
              clientCard: this.treatmentFree,
              staffRevenues,
              name: this.treatmentFree?.name,
              department: values?.department,
            };
          } else {
            this.openCreateOrEditTreatmentPlanPopup = false;
            this.pagingRegisterTreatmentPlan();
          }
        }
        return data;
      }
    } catch (error) {
      console.error(error);
      toast.error("Lưu thông tin đăng ký thẻ liệu trình có lỗi");
    }
  };

  saveOrUpdateTreatmentPlanAdvice = async (values) => {
    return await saveOrEditTreatmentPlanCard(values)
      .then(({ data }) => {
        this.openUpdateTreatmentPlanAdvicePopup = false;
        toast.success("Đăng ký liệu trình từ tư vấn thành công");
        getListTreatmentPlanCard(this.searchListTreatmentPlanAdvice).then(
          ({ data }) => {
            this.dataRegisterTreatmentPlan = data;
          }
        );
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin đăng ký liệu trình từ tư vấn có lỗi");
      });
  };

  createPaymentVoucherWithListMethod = async (values) => {
    return await createPaymentVoucherWithListMethod(values)
      .then(({ data }) => {
        toast.success("Tạo phiếu chi thành công");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Tạo phiếu chi có lỗi");
      });
  };

  handleChangeFormSearchTreatmentPlan = (searchRegisterTreatmentPlan) => {
    this.searchRegisterTreatmentPlan = {
      ...this.searchRegisterTreatmentPlan,
      ...searchRegisterTreatmentPlan,
    };
    this.pagingRegisterTreatmentPlan();
  };
  handleChangeFormSearchTreatmentPlanAdvice = (obj) => {
    this.searchListTreatmentPlanAdvice = {
      ...this.searchListTreatmentPlanAdvice,
      ...obj,
    };
    this.pagingRegisterTreatmentPlanAdvice();
  };

  handleOpenCreateOrEditTreatmentPlanPopup = async (
    treatmentPlan,
    patient,
    customerSourceWalkIn,
    defaultDepartment
  ) => {
    console.log("🚀 ~ handleOpenCreateOrEditTreatmentPlanPopup ~ treatmentPlan:", treatmentPlan)
    let searchCodeSource = {};
    if (Boolean(treatmentPlan)) {
      getTreatmentPlanCardById(treatmentPlan?.id).then(async ({ data }) => {
        let totalAmount = 0;
        let selectedVoucher = null;
        let promotionCodes = new Set();

        if (data?.drugs?.length > 0) {
          let drugs = data?.drugs?.map((el) => {
            const amount =
              (el?.price || 0) * el?.soldQuantity - (el?.discount || 0);
            totalAmount += +(el?.price * el?.soldQuantity);

            // gom mã CTKM
            if (el?.promotionProgram?.code) {
              promotionCodes.add(el?.promotionProgram?.code);
            }

            return {
              ...el,
              taxPercent: el?.taxPercent ? el?.taxPercent?.toString() : "0",
              amount,
              fees: el?.drug?.drugUnitPrices
                ?.filter(f => f?.isUse === true) 
                ?.map((el) => ({
                  ...el?.patientTypeService,
                  price: el?.price,
                  vatIncluded: el?.vatIncluded,
                  serviceVAT: el?.serviceVAT,
                  patientTypeService: el?.patientTypeService,
              })),
              isDisabledCTKM:
                el?.promotionProgram &&
                el?.promotionProgram?.code !== PROMOTION_DEFAULT_CODE &&
                !PROMOTION_CODES?.includes(el?.promotionProgram?.code),
            };
          });
          data.drugs = drugs;
        }
        if (data?.paServiceRegister?.length > 0) {
          const paServiceRegister = data?.paServiceRegister?.map((el) => {
            const amount =
              (el?.price || 0) * el?.quantity - (el?.discount || 0);
            totalAmount += +((el?.price || 0) * el?.quantity);
            // gom mã CTKM
            if (el?.promotionProgram?.code) {
              promotionCodes.add(el?.promotionProgram?.code);
            }
            return {
              ...el,
              taxPercent: el?.taxPercent ? el?.taxPercent?.toString() : "0",
              amount,
              fees: el?.service?.serviceFeeList
                ?.filter(f => f?.isUsing === true) 
                ?.map((el) => ({
                  ...el?.patientTypeService,
                  price: el?.price,
                  vatIncluded: el?.vatIncluded,
                  serviceVAT: el?.serviceVAT,
                  patientTypeService: el?.patientTypeService,
              })),
              isDisabledCTKM:
                el?.promotionProgram &&
                el?.promotionProgram?.code !== PROMOTION_DEFAULT_CODE &&
                !PROMOTION_CODES?.includes(el?.promotionProgram?.code),
            };
          });
          data.paServiceRegister = paServiceRegister;
        }

        // tổng tiền = price - tiền khấu trừ
        data.totalAmount = totalAmount;

        // Nếu tất cả item đều có 1 mã CTKM duy nhất và không phải mã mặc định → chọn mã đó
        if (
          promotionCodes.size === 1 &&
          !promotionCodes.has(PROMOTION_DEFAULT_CODE)
        ) {
          const onlyCode = [...promotionCodes][0];

          // tìm product có promotionProgram tương ứng
          const allItems = [
            ...(data.drugs || []),
            ...(data.paServiceRegister || []),
          ];

          const item = allItems.find(
            (el) => el?.promotionProgram?.code === onlyCode
          );

          selectedVoucher = item?.promotionProgram || null;
        } else {
          // Các sản phẩm KHÔNG cùng CTKM → selectedVoucher = null
          selectedVoucher = null;
        }

        data.selectedVoucher = selectedVoucher;

        // Fetch full CTKM data cho từng item có promotionProgram (cần truyền productCode)
        try {
          // Fetch CTKM cho drugs
          if (data?.drugs?.length > 0) {
            const drugsPromises = data.drugs.map(async (drug) => {
              if (drug?.promotionProgram?.code && drug?.drug?.code) {
                try {
                  const { data: ctkmResponse } = await pagingProgram({
                    codes: [drug.promotionProgram.code],
                    productCode: drug.drug.code,
                    pageSize: 10,
                  });
                  const fullCtkm = ctkmResponse?.content?.[0];
                  if (fullCtkm) {
                    return { ...drug, promotionProgram: fullCtkm };
                  }
                } catch (error) {
                  console.error("Error fetching CTKM for drug:", error);
                }
              }
              return drug;
            });
            data.drugs = await Promise.all(drugsPromises);
          }

          // Fetch CTKM cho paServiceRegister
          if (data?.paServiceRegister?.length > 0) {
            const servicesPromises = data.paServiceRegister.map(async (service) => {
              if (service?.promotionProgram?.code && service?.service?.code) {
                try {
                  const { data: ctkmResponse } = await pagingProgram({
                    codes: [service.promotionProgram.code],
                    productCode: service.service.code,
                    pageSize: 10,
                  });
                  const fullCtkm = ctkmResponse?.content?.[0];
                  if (fullCtkm) {
                    return { ...service, promotionProgram: fullCtkm };
                  }
                } catch (error) {
                  console.error("Error fetching CTKM for service:", error);
                }
              }
              return service;
            });
            data.paServiceRegister = await Promise.all(servicesPromises);
          }

          // Update selectedVoucher with full data if needed
          if (data?.selectedVoucher?.code) {
            // Lấy productCode từ item đầu tiên có cùng CTKM
            const allItems = [...(data.drugs || []), ...(data.paServiceRegister || [])];
            const itemWithSameCtkm = allItems.find(
              (el) => el?.promotionProgram?.code === data.selectedVoucher.code
            );
            if (itemWithSameCtkm?.promotionProgram) {
              data.selectedVoucher = itemWithSameCtkm.promotionProgram;
            }
          }
        } catch (error) {
          console.error("Error fetching full CTKM data:", error);
        }

        this.initRegisterTreatmentPlan = data;
        this.openCreateOrEditTreatmentPlanPopup = true;
        searchCodeSource = {
          visitId: this.initRegisterTreatmentPlan?.visit?.id,
          patientId: patient?.id || this.initRegisterTreatmentPlan?.patient?.id,
          departmentId: this.initRegisterTreatmentPlan?.department?.id,
          voucherIds: this.initRegisterTreatmentPlan?.voucherAllocations?.map(item => item?.voucher?.id) || [],
          invoiceItemIds: this.initRegisterTreatmentPlan?.invoiceItemAllocations?.map(item => item?.invoiceItem?.id) || []
        };
        this.handleGetListCodeSource(searchCodeSource);
      });
    } else {
      let revenueAllocations = this.treatmentFree?.revenueAllocations || [];
      let staffRevenues = [];
      console.log("🚀 ~ handleOpenCreateOrEditTreatmentPlanPopup ~ revenueAllocations:", revenueAllocations)
      if (revenueAllocations) {
        staffRevenues = revenueAllocations?.map((el) => ({
          position: el?.position,
          percentRevenue: el?.commissionRate,
          source: patient?.currentPatientSource
            ? patient?.currentPatientSource
            : customerSourceWalkIn,
          actualAmount: 0,
          staff:
            patient?.currentConsultant?.position?.code === el?.position?.code
              ? patient?.currentConsultant
              : patient?.currentTelesale?.position?.code === el?.position?.code
                ? patient?.currentTelesale
                : null,
        }));
      }
      this.initRegisterTreatmentPlan = {
        ...new RegisterCard(),
        clientCard: this.treatmentFree,
        staffRevenues,
        name: this.treatmentFree?.name,
      };

      // Try to fetch visit for this treatment plan (server-side lookup)
      try {
        const api = ConstantList.API_EN_POINT + "/visit/find-for-treatment-plant-card";
        const dto = {
          patientId: patient?.id,
          startDate: this.initRegisterTreatmentPlan?.startDate || new Date(),
          departmentId: defaultDepartment?.id,
        };
        const { data: visitData } = await axios.post(api, dto);
        if (visitData) {
          this.initRegisterTreatmentPlan.visit = visitData;
        } else {
          // no visit found: show confirmation/check-in info to user
          this.openConfirmMessage = "Khách hàng chưa có lần check-in phù hợp. Vui lòng kiểm tra thông tin check-in.";
        }
      } catch (error) {
        console.error("Error fetching visit for treatment plan:", error);
      }

      this.openCreateOrEditTreatmentPlanPopup = true;

      searchCodeSource = {
        level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
        startDate: this.initRegisterTreatmentPlan?.startDate || new Date(),
        patientId: patient?.id,
        departmentId: defaultDepartment?.id,
      };
      this.handleGetListCodeSource(searchCodeSource);
    }
  };

  handleGetListCodeSource = async (obj) => {
    try {
      const { data } = await getListCode(obj);
      runInAction(() => {
        this.listCodeSource = data || [];
      });
    } catch (error) {
      //console.error(error);
    }
  };

  handleOpenChangeTreatmentPlanPopup = async (treatmentPlan, patient) => {
    try {
      let searchCodeSource = {};
      const { data } = await getInitChangeTreatment(treatmentPlan?.id);
      if (data) {
        let { oldTreatmentPlanCard, responseStatus, responseDetail } = data;
        if (responseStatus === false) {
          this.responseDetailFormChangeTreament =
            responseDetail || "Đổi liệu trình thất bại";
          this.openPopupComfirms = true;
          return;
        }
        let remainingAmount = oldTreatmentPlanCard?.remainingAmount;

        oldTreatmentPlanCard.remainingAmount = remainingAmount; // tổng tiền còn lại
        oldTreatmentPlanCard.oldTreatmentCredit = remainingAmount; // tiền khấu trừ lộ trình cũ

        // let formatStaffRevenues = oldTreatmentPlanCard?.staffRevenues?.map((el) => ({
        //   ...el,
        //   actualAmount: 0,
        //   percentRevenue: el?.percentRevenue ?? 100,
        //   oldPercentRevenue: el?.percentRevenue,
        // }));
        // oldTreatmentPlanCard.staffRevenues = formatStaffRevenues;

        // Không cần fetch CTKM cho old items vì chỉ hiển thị, không edit

        this.initChangeTreatmentPlan = {
          oldTreatmentPlanCard,
          ...new RegisterCard(),
          //staffRevenues: formatStaffRevenues,
          staffRevenues: [],
          oldTreatmentCredit: oldTreatmentPlanCard?.oldTreatmentCredit,
          clientCard: this.treatmentFree,
          price: 0,
          totalAmount: 0,
        };
        this.openChangeTreatmentPlanPopup = true;

        searchCodeSource = {
          level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
          startDate: oldTreatmentPlanCard?.startDate || new Date(),
          patientId: patient?.id,
          departmentId: oldTreatmentPlanCard?.department?.id
        };
        this.handleGetListCodeSource(searchCodeSource);
      }
    } catch (error) {
      // if (error.response?.status === 403) {
      //   toast.error("Bạn không có quyền truy cập thông tin liệu trình");
      // } else {
      toast.error("Lấy thông tin liệu trình có lỗi");
      //}
    }
  };

  handleClosePopupCofirmTrement = () => {
    this.openPopupComfirms = false;
  };

  handleChangeTreatment = async (values) => {
    let {
      newProduct,
      oldProduct,
      oldTreatmentPlanCard,
      stopTreatment,
      ...ortherData
    } = values;
    let obj = {
      oldTreatmentPlanCard,
    };
    if (!stopTreatment) {
      obj.newTreatmentPlanCard = ortherData;
    }
    try {
      const { data } = await changeTreatment(obj);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmMessage = data?.responseDetail;
        }, 500);
        return data;
      } else if (stopTreatment) {
        toast.success("Dừng liệu trình thành công");
      } else {
        this.openChangeTreatmentPlanPopup = false;
        toast.success("Đổi liệu trình thành công");
      }
      this.pagingRegisterTreatmentPlan();
      return data;
    } catch (error) {
      console.error(error);
      toast.error("Đổi liệu trình có lỗi");
    }
  };

  handleOpenAddTreatmentPlanAdvicePopup = async (obj) => {
    try {
      this.searchListTreatmentPlanAdvice = {
        ...this.searchListTreatmentPlanAdvice,
        ...obj,
      };
      this.pagingRegisterTreatmentPlanAdvice();
      this.openAddTreatmentPlanAdvicePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  handleAddTreatmentPlanAdvicePopup = async (
    data,
    patient,
    customerSourceWalkIn
  ) => {
    let { clientCard, paiPatientTypeService, paiPrice, ...ortherData } = data;
    let currentConsultant = patient?.currentConsultant;
    let currentTelesale = patient?.currentTelesale || patient?.currentTelesale2;
    let totalAmount;
    let totalAmountServices = 0;
    let totalAmountDrugs = 0;
    let feeItem;
    if (paiPatientTypeService && clientCard?.clientCardFees?.length > 0) {
      feeItem = clientCard?.clientCardFees?.find(
        (el) => el?.patientTypeService?.id === paiPatientTypeService?.id
      );
    } else {
      feeItem =
        clientCard?.clientCardFees?.length > 0
          ? getPriceTypeService(
            data?.patientTypeService,
            clientCard?.clientCardFees
          )
          : null;
    }

    if (clientCard?.services && clientCard?.services?.length > 0) {
      totalAmountServices = clientCard?.services?.reduce((acc, curr) => {
        return acc + (curr?.quantity || 1) * curr?.netPrice;
      }, 0);
    }
    if (clientCard?.products && clientCard?.products?.length > 0) {
      totalAmountDrugs = clientCard?.products?.reduce((acc, curr) => {
        return acc + (curr?.quantity || 1) * curr?.netPrice;
      }, 0);
    }
    console.log("totalAmountDrugs", totalAmountDrugs);
    console.log("totalAmountServices", totalAmountServices);

    let price = (totalAmount =
      paiPrice || feeItem?.price || clientCard?.totalNetPrice);

    if (
      (clientCard?.services && clientCard?.services?.length > 0) ||
      (clientCard?.products && clientCard?.products?.length > 0)
    ) {
      let formatDataService;
      let formatDataDrug;
      const totalAmountItem = +totalAmountServices + +totalAmountDrugs;
      if (totalAmount < totalAmountItem) {
        const percentAllocateItem =
          (totalAmountItem - totalAmount) / totalAmountItem;
        formatDataService = clientCard?.services?.map((el) => {
          const feeSv =
            el?.fees?.length > 0
              ? getPriceTypeService(el?.patientTypeService, el?.fees || [])
              : null;

          let taxTotal = 0;
          let taxPercent = feeSv?.serviceVAT?.vatPercent?.toString() || 0;

          if (feeSv?.vatIncluded) {
            taxTotal =
              ((el?.netPrice * el?.quantity - (el?.discount || 0)) /
                (+taxPercent + 100)) *
              +taxPercent;
          } else {
            taxTotal =
              (el?.netPrice * el?.quantity - (el?.discount || 0)) *
              ((+taxPercent || 0) / 100);
          }

          return {
            service: el?.service,
            quantity: el?.unLimited ? 1 : el?.quantity,
            note: "",
            unLimited: el?.unLimited,
            price: el?.netPrice,
            percentDiscount: percentAllocateItem * 100,
            discount:
              percentAllocateItem *
              el?.netPrice *
              (el?.unLimited ? 1 : el?.quantity),
            isEditable: el?.isEditable,
            taxPercent,
            taxTotal,
            priceWithTax: feeSv?.vatIncluded,
            fees: el?.fees?.map((el) => ({
              ...el?.patientTypeService,
              price: el?.price,
              vatIncluded: el?.vatIncluded,
              serviceVAT: el?.serviceVAT,
              patientTypeService: el?.patientTypeService,
            })),
            patientTypeService: feeSv,
          };
        });

        formatDataDrug = clientCard?.products?.map((el) => ({
          drug: el?.drug,
          soldQuantity: el?.unLimited ? 1 : el?.quantity,
          price: el?.netPrice,
          percentDiscount: percentAllocateItem * 100,

          discount:
            percentAllocateItem *
            el?.netPrice *
            (el?.unLimited ? 1 : el?.quantity),
          isEditable: el?.isEditable,
        }));
        console.log("percentAllocateItem", percentAllocateItem);
        console.log("totalAmount", totalAmount);
        ortherData.discount = totalAmountItem - totalAmount;
      }

      let revenueAllocations = clientCard?.revenueAllocations;
      if (revenueAllocations) {
        let staffRevenues = revenueAllocations?.map((el) => ({
          position: el?.position,
          percentRevenue: el?.commissionRate,
          source: patient?.currentPatientSource
            ? patient?.currentPatientSource
            : customerSourceWalkIn,
          staff:
            currentConsultant?.position?.code === el?.position?.code
              ? currentConsultant
              : currentTelesale?.position?.code === el?.position?.code
                ? currentTelesale
                : null,
        }));
        ortherData.staffRevenues = staffRevenues;
      }
      ortherData.paServiceRegister = formatDataService;
      ortherData.drugs = formatDataDrug;
    } else {
      ortherData.paServiceRegister = [];
      ortherData.drugs = [];
    }

    let formatData = {
      ...ortherData,
      price,
      totalAmount,
      patientTypeService: {
        ...feeItem?.patientTypeService,
        price: feeItem?.price,
      },
      clientCard,
    };

    this.initRegisterTreatmentPlan = formatData;
    this.openUpdateTreatmentPlanAdvicePopup = true;
  };

  handleCloseAddTreatmentPlanAdvicePopup = () => {
    this.openAddTreatmentPlanAdvicePopup = false;
  };
  handleCloseChangeTreatmentPlanPopup = () => {
    this.openChangeTreatmentPlanPopup = false;
  };

  handleCloseUpdateTreatmentPlanAdvicePopup = () => {
    this.openUpdateTreatmentPlanAdvicePopup = false;
  };

  handleCloseCreateOrEditServicePopup = () => {
    this.openCreateOrEditTreatmentPlanPopup = false;
    this.initRegisterTreatmentPlan = { ...new RegisterCard() };
  };

  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };

  handleDeleteTreatmentPlanCard = async () => {
    return await removeTreatmentPlanCardUser(this.openConfirmDelete)
      .then(({ data }) => {
        this.openConfirmDelete = null;
        if (data?.responseStatus === false) {
          setTimeout(() => {
            this.openConfirmDeleteMessage = data?.responseDetail;
          }, 500);
          return;
        } else {
          toast.success("Xóa thẻ liệu trình thành công");
          this.pagingRegisterTreatmentPlan();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa thẻ liệu trình có lỗi");
      });
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  handleCloseDeleteConfirmMessage = () => {
    this.openConfirmDeleteMessage = null;
  };

  handleCloseInvalidMessage = () => {
    this.openInvalidMessage = null;
  };

  getTreatmentFree = async () => {
    return await pagingClientCard({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      keyword: TREATMENT_FREE,
      type: TYPE_CARD[1].value,
    })
      .then(({ data }) => {
        this.treatmentFree = data?.content?.[0];
        console.log("🚀 ~ getTreatmentFree ~ this.treatmentFree:", this.treatmentFree)
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hình thức thanh toán có lỗi");
      });
  };

  handleOpenConfirmUnlock = (id) => {
    this.openConfirmUnlock = id;
  };

  handleCloseConfirmUnlock = () => {
    this.openConfirmUnlock = null;
  };

  handleConfirmUnlock = async () => {
    try {
      const { data } = await unLockTreatment(this.openConfirmUnlock);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmDeleteMessage = data?.responseDetail;
        }, 300);
      } else {
        toast.success("Mở khóa thành công");
        this.pagingRegisterTreatmentPlan();
      }
      this.openConfirmDeleteMessage = null;
      this.openConfirmUnlock = null;
    } catch (error) {
      toast.error(error);
    }
  };

  handleOpenConfirmError = () => {
    this.openConfirmError = null;
  };

  handleOpenConfirmlock = (id) => {
    this.openConfirmLock = id;
  };

  handleCloseConfirmLock = () => {
    this.openConfirmLock = null;
  };

  handleConfirmLock = async () => {
    try {
      const { data } = await lockTreatment(this.openConfirmLock);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          this.openConfirmError = data?.responseDetail;
        }, 300);
      } else {
        toast.success("Khóa thành công");
        this.pagingRegisterTreatmentPlan();
      }
      this.openConfirmLock = null;
    } catch (error) {
      toast.error(error);
    }
  };

  handleCloseHistoryTreatmentPopup = async () => {
    this.openHistoryTreatmentPopup = false;
    this.searchDataHistory = null;
  };

  handleChangeFormSearchHistory = (searchDataHistory) => {
    this.searchDataHistory = {
      ...this.searchDataHistory,
      ...searchDataHistory,
    };
    this.pagingHistory();
  };

  pagingHistory = async () => {
    try {
      const { data } = await elasticTreatmentPlanCardHistory({
        ...this.searchDataHistory,
      });

      this.pageDataHistory = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu lịch sử liệu trình có lỗi");
    }
  };

  handleOpenHistoryTreatmentPopup = async (values) => {
    try {
      this.handleChangeFormSearchHistory(values);
      this.openHistoryTreatmentPopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  getTreatmentTimesEachServices = async (id) => {
    try {
      const { data } = await getTreatmentTimesEachServices(id);

      toast.success("Thành công");
      this.pagingRegisterTreatmentPlan();
    } catch (error) {
      toast.error(error);
    }
  };

  resetStore = () => {
    this.searchRegisterTreatmentPlan = {
      ...new SearchObject(),
      fromDate: new Date(new Date().getFullYear(), 0, 1),
      toDate: new Date(),
      type: TYPE_CARD[1].value,
    };
    this.pageRegisterTreatmentPlan = new PageResponse();
    this.openCreateOrEditTreatmentPlanPopup = false;
    this.initRegisterTreatmentPlan = { ...new RegisterCard() };
    this.openConfirmMessage = null;
    this.openAddTreatmentPlanAdvicePopup = false;
    this.openUpdateTreatmentPlanAdvicePopup = false;
    this.searchListTreatmentPlanAdvice = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
    this.dataRegisterTreatmentPlan = [];
    // this.treatmentFree = null;
    this.listCodeSource = [];
  };
}
